import {APIError} from 'helpers/Rest';
import { unfilteredSegmentList } from 'selectors/productSelector';
import { normalizeSegments } from 'reducers/products';

import { getProducts } from './ProductActions';
import { setUserSettings } from './UserActions';
import { persistProject } from './helpers/persistProject';

function receivedProducts(products) {
  return {type: 'products/received', products: normalizeSegments(products)};
}

export function getProductsByPrefix(prefix) {
  return async (dispatch) => {
    try {
      const products = await dispatch(getProducts({prefix}));
      dispatch(receivedProducts(products));
    } catch (e) {
      if (e instanceof APIError) {
        if (e.statusCode >= 500 || e.statusCode === 0) {
          alert(`Failed to load products for ${prefix}. Please check your internet connection.\n${e}`);
        }
      } else {
        throw e;
      }
    }
  }
}

export function addLoad(id) {
  return persistProject({type: 'load/add', id});
}

export function removeLoad(id) {
  return persistProject({type: 'load/remove', id});
}

export function updateLoad(id, load) {
  return persistProject({type: 'load/update', id, load});
}

export function setLoadPileType(id, pileType) {
  return persistProject((dispatch) => {
    dispatch({type: 'load/update', id, load: {pileType}});
    dispatch(setUserSettings({defaultPileType: pileType}));
  });
}

export function updateLoadPileFilter(loadId, filters) {
  return persistProject((dispatch, getState) => {
    const products = unfilteredSegmentList(getState());
    dispatch({type: 'load/pile/update', loadId, filters, products});
  });
}

export function setLoadLead(loadId, lead) {
  return persistProject((dispatch, getState) => {
    const products = unfilteredSegmentList(getState());
    const filters = _.pick(lead, 'helixConfig');
    dispatch({type: 'load/pile/update', loadId, lead, filters, products});
  });
}

export function updateLogs(logs) {
  return persistProject({type: 'logs/update', logs});
}

export function updateLog(loadId, pileNumber, log) {
  log = {updatedAt: new Date().toISOString(), ...log};
  return persistProject({type: 'logs/update/pile', loadId, pileNumber, log});
}

export function clearLog(loadId, pileNumber) {
  return persistProject({type: 'logs/reset/pile', loadId, pileNumber});
}
